var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24414 4.73365C5.33081 3.64699 6.87081 3.02032 8.56414 3.19365C11.0108 3.44032 13.0241 5.42699 13.2975 7.87365C13.6641 11.107 11.1641 13.8337 8.01081 13.8337C5.88414 13.8337 4.05748 12.587 3.20414 10.7937C2.99081 10.347 3.31081 9.83365 3.80414 9.83365C4.05081 9.83365 4.28414 9.96699 4.39081 10.187C5.14414 11.807 6.95081 12.8337 8.92414 12.3937C10.4041 12.067 11.5975 10.8603 11.9108 9.38032C12.4708 6.79365 10.5041 4.50032 8.01081 4.50032C6.90414 4.50032 5.91748 4.96032 5.19748 5.68699L6.20414 6.69365C6.62414 7.11365 6.33081 7.83365 5.73748 7.83365H3.34414C2.97748 7.83365 2.67748 7.53365 2.67748 7.16699V4.77365C2.67748 4.18032 3.39748 3.88032 3.81748 4.30032L4.24414 4.73365Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.3de66586a5e4b8760f23aa07abded0c5.svg";
export { ForwardRef as ReactComponent };